import type { HubConnection } from '@microsoft/signalr'
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr'

import type { Payload } from './store/types'

interface ConnectToSignalRArgs {
  url: string
  accessToken: string
  onNewMessageReceived: (data: Payload) => void
  onNewEventReceived: (data: Payload) => void
}

const connectToSignalR = ({
  url,
  accessToken,
  onNewMessageReceived,
  onNewEventReceived,
}: ConnectToSignalRArgs): Promise<HubConnection> => {
  console.debug('Connecting to SignalR')

  const options = {
    accessTokenFactory: () => accessToken,
  }

  const connection = new HubConnectionBuilder()
    .withUrl(url, options)
    .configureLogging(LogLevel.Warning)
    .withAutomaticReconnect()
    .build()

  connection.on('newMessage', (data: Payload) => {
    if (!data) {
      console.warn('Received SignalR message containing no data')
      return
    }

    console.debug('Received SignalR message')

    onNewMessageReceived(data)
  })

  connection.on('newEvent', data => {
    if (!data) {
      console.warn('Received SignalR event containing no data')
      return
    }

    console.debug('Received SignalR event')

    onNewEventReceived(data)
  })

  connection.onclose(() => console.debug('Disconnected from SignalR'))

  return connection.start().then(() => {
    console.debug('Connected to SignalR')

    return Promise.resolve(connection)
  })
}

export default connectToSignalR
